import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router-dom';

import * as palette from '../../../../components/General/Variables';
import AuthUserContext from '../../../../components/Session/AuthUserContext';
import Header from '../../components/common/Header';
import { getTimeslot } from '../../services/session';
import { getFullProfile } from '../../../../services/api/eureka';
import Auth from '../../../../services/api/auth';
import { Wrapper } from '../../styles';
import { goBackFromVirtualSession } from '../common/goBack';
import { checkIfUserHasAuthorizationByTypeRestrictions } from '../../../AccessRestrictions/utils';
import AccessDeniedModal from '../../../AccessRestrictions/AccessDeniedModal';

const OnDemandMetaFusionSession = props => {
    const { authUser, match, history, location } = props;
    const { timeslotId } = match.params;
    const [timeslot, setTimeslot] = useState({});
    const mobile = (window.innerWidth < palette.MIN_TABLET_INT).toString();
    const [restrictedUser, setRestrictedUser] = useState(false);

    const goBackFunction = () => goBackFromVirtualSession(match, history, location, timeslotId);

    useEffect(() => {
        if (location.state && location.state.keepHistoryLength) {
            history.replace(location.pathname, {
                ...location.state,
                keepHistoryLength: false,
            });
            sessionStorage.setItem(timeslotId + '_history_index', JSON.stringify(history.length));
        }
        getTimeslot(timeslotId, async (err, timeslot) => {
            if (err || !timeslot) {
                return;
            }

            setTimeslot(timeslot);

            if (Auth.isUserAuthenticated()) {
                const fullProfile = await getFullProfile();
                const canUserAccessSession = checkIfUserHasAuthorizationByTypeRestrictions(
                    timeslot?.typeParams?.virtualRoomRestrictedGroup,
                    fullProfile.userGroups,
                );
                setRestrictedUser(!canUserAccessSession);
            }
        });
    }, [timeslotId]);

    const goBack = () => {
        return goBackFunction();
    };

    if (restrictedUser) {
        return <AccessDeniedModal onClose={() => history.push('/')} />;
    }

    return (
        <React.Fragment>
            {authUser && (
                <Wrapper mobile={mobile}>
                    <Header goBack={goBack} timeslot={timeslot} authUser={authUser} />
                    <div style={{ paddingTop: 56 }}>
                        <meta-player
                            id="139421"
                            slug={timeslot?.params?.onDemandMetafusionId}
                            aiFeatures={true}
                            subtitleFeatures={true}
                            transcriptSearchFeature={true}
                            transcriptDownloadFeature={true}
                            transcriptLanguages={[
                                { language: 'German', isoCode: 'de', value: true },
                                { language: 'Dutch', isoCode: 'nl', value: true },
                                { language: 'English', isoCode: 'en', value: true },
                            ]}
                        />
                    </div>
                </Wrapper>
            )}
        </React.Fragment>
    );
};

const ConsumerWrapper = props => {
    return (
        <AuthUserContext.Consumer>
            {authUser => <OnDemandMetaFusionSession {...props} authUser={authUser} />}
        </AuthUserContext.Consumer>
    );
};

export default withRouter(ConsumerWrapper);
